module.exports = __webpack_public_path__ + "static/media/16_b1.695bf752.png";